/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { tasksService } from '../../../_services/tasks.service'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import { unitTasksService } from '../../../_services/unitTasks.service'
import ConfirmDialog from '../../Shared/ConfirmDialog'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal
        ? this.props.taskType
        : this.props.match.params.taskType,
      data: {
        categoryId: '',
        brandId: '',
        productId: '',
        quantity: '',
        description: '',
        items: [{ categoryId: '', brandId: '', productId: '', quantity: 0 }]
      }
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      this.setState({ loading: true })

      await unitTasksService
        .getByIdWhm(id)
        .then(res => {
          let data = res.data

          console.log(res)

          data['lastDescription'] = data.description
          data['description'] = ''

          data['categoryId'] = data.product.categoryId
          data['brandId'] = data.product.brandId
          // data["subQuantity"] = Math.round(data.quantity / data.product.conversionUnit)
          data['subQuantity'] = Number(
            (data.quantity / data.product.conversionUnit).toFixed(3)
          )

          if (data.items && data.items.length>0) {
            data.items.forEach(item => {
              item['extraQuantity'] = undefined
              item['subExtraQuantity'] = undefined
              item['taskOperationProductType'] = 1
              item['waste'] = 0
              item['subWaste'] = 0

              // item["categoryId"] = item.product.categoryId;
              // item["brandId"] = item.product.brandId;
            })
          }
          console.log(data)
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          // console.log(error);

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    setSubmitting(false)

    let dto = {}
    dto['taskId'] = this.state.data.taskId
    dto['PreviousUnitTaskId'] = this.state.data.id
    dto['description'] = values.description
    dto['taskFinished'] = true
    dto['items'] = values.items

    console.log(dto)

    // taskOperationsService.pmAddTaskOperation(JSON.stringify(values))
    //   .then((res) => {
    //     console.log(res);

    //     this.setState({ loading: false, data: res.data, key: "images" });
    //     toastr.success('ارجاع سفارش انجام شد');
    //     // history.push("/admin/tasks/pm")

    //     setSubmitting(false);

    //     this.props.onSubmit()

    //   })
    //   .catch((error) => {
    //     // console.log(error)
    //     setSubmitting(false);
    //   });

    this.setState({ finalDto: dto }, () => {
      this.handleShowConfirmDialog(true)
    })
  }

  handleShowConfirmDialog = val => {
    this.setState({ confirmDialogShow: val })
  }

  handleSubmitAfterConfirm = () => {
    this.handleShowConfirmDialog(false)

    this.setState({ taskFinishedLoading: true })
    console.log(JSON.stringify(this.state.finalDto))
    taskOperationsService
      .whmFinishTaskOperation(JSON.stringify(this.state.finalDto))
      .then(result => {
        let res = result.data
        console.log(res)
        if (res === 1) {
          this.setState({
            loading: false,
            taskFinishedLoading: false,
            taskSemiFinishedLoading: false
          })
          toastr.success('ثبت اطلاعات انجام شد')
          this.props.onSubmit()
        } else if (res === -1) {
          this.setState({
            loading: false,
            taskFinishedLoading: false,
            taskSemiFinishedLoading: false
          })
          toastr.warning(
            'مشکلی در ثبت اطلاعات پیش آمد. لطفا به مدیر سیستم اطلاع دهید.'
          )
        }
      })
      .catch(error => {
        console.log(error)
        this.setState({
          loading: false,
          taskFinishedLoading: false,
          taskSemiFinishedLoading: false
        })
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  // validateForm = (errors) => {
  //   if (Object.keys(errors).length > 0) {
  //     // // console.log(errors)
  //     let obj = errors
  //     let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
  //       driverDocuments,
  //       user
  //     } = obj;
  //     if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
  //       this.setState({ key: "info" })
  //     } else if (driverDocuments) {
  //       this.setState({ key: "images" })
  //     }
  //   }
  // }

  render() {
    const { data, taskFinishedLoading } = this.state
    const itemsCount = data && data.items ? data.items.length : 0

    const item = Yup.object().shape({
      extraQuantity: Yup.number()
        .nullable()
        .required('مغایرت')
      // productId: Yup.string().trim().nullable().required('محصول')
    })

    const ValidationSchema = Yup.object().shape({
      // items: Yup.array().of(item).min(itemsCount, 'تمامی اطلاعات').required('تمامی اطلاعات محصول'),
    })
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  {/* <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات فرآیند تولید"> */}
                  <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                      <Step1 {...props} taskType={this.state.taskType} />
                      <Step2 {...props} taskType={this.state.taskType} />
                      {values.unitTaskStatus === 0 && (
                        <Step3 {...props} taskType={this.state.taskType} />
                      )}
                    </div>
                    {values.unitTaskStatus === 0 && (
                      <div className="col-lg-10 col-lg-offset-1">
                        <button
                          type="submit"
                          className={
                            'btn btn-primary btn-block btn-ripple btn-font-lg' +
                            (isSubmitting ? 'isSubmitting' : '')
                          }
                          disabled={
                            taskFinishedLoading || values.unitTaskStatus === 3
                          }
                          onClick={e => {
                            e.preventDefault()
                            console.log(errors)
                            this.setState(
                              {
                                dialogTitle:
                                  'آیا اطلاعات کالاهای وارد شده به انبار را تائید می کنید؟',
                                dialogText:
                                  'مقادیر فوق پس از ورود به انبار، امکان ویرایش نخواهند داشت'
                              },
                              () => {
                                handleSubmit()
                              }
                            )
                          }}>
                          {taskFinishedLoading ? (
                            <AiOutlineLoading
                              className="mdi-spin"
                              size="22px"
                            />
                          ) : (
                            'تایید اطلاعات و وارد کردن کالاها به انبار'
                          )}
                        </button>
                      </div>
                    )}
                  </div>

                  {/* </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه"> */}

                  {/* </Tab>

                  </Tabs> */}
                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              <ConfirmDialog
                open={this.state.confirmDialogShow}
                onClose={() => this.handleShowConfirmDialog(false)}
                onConfirm={() => this.handleSubmitAfterConfirm()}
                title={this.state.dialogTitle}
                text={this.state.dialogText}
              />
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default Form
